/*
 * Copyright (c) 2024 NOOGA DEVELOPMENT, All rights reserved.
 * Author Julia Romanovskaya <julia.romanovskaya@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { switchMap, map, catchError, takeUntil, exhaustMap, tap, mapTo } from 'rxjs/operators';
import { cashboxesClient } from '../../../api/cashBoxes/cashboxesClient';
import { from, of } from 'rxjs';
import {
    CashBoxReplacementTabActionType,
    CashBoxReplacementTabAction,
    fetchCashBoxReplacementHistorySuccessAction,
    fetchCashBoxReplacementHistoryErrorAction,
    downloadReplacementHistorySuccessAction,
    downloadReplacementHistoryErrorAction,
} from '../../../actions/CashBoxRegistry/Tabs/cashBoxReplacementTabActions';
import { downloadDataAsFile, parseError } from '../../../../utils/utils';
import { i18n } from '../../../translation/i18n';
import { AxiosError } from 'axios';

export const fetchCashBoxReplacementHistoryEpic: Epic<CashBoxReplacementTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxReplacementTabActionType.FETCH_CASHBOX_REPLACEMENT_HISTORY),
        switchMap(() => {
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const listName = i18n.t('RegistryScreens.cashBoxReplacementHistory').toLowerCase();

            return from(cashboxesClient.getCashBoxReplacementHistory(taxNumber)).pipe(
                map((resp) => {
                    return fetchCashBoxReplacementHistorySuccessAction(resp);
                }),
                catchError((err: AxiosError) =>
                    of(
                        fetchCashBoxReplacementHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedLoadList', { listName })),
                        ),
                    ),
                ),
                takeUntil(action$.ofType(CashBoxReplacementTabActionType.EXIT_CASHBOX_REPLACEMENT_TAB)),
            );
        }),
    );
};

export const cashBoxReplacementHistoryDownloadEpic: Epic<CashBoxReplacementTabAction> = (action$, state$) => {
    return action$.pipe(
        ofType(CashBoxReplacementTabActionType.DOWNLOAD_REPLACEMENT_HISTORY),
        exhaustMap(() => {
            const taxNumber = state$.value.routerState.route.params.CashboxTaxNumber;
            const fileName = `cashbox_${taxNumber}_ReplacementHistory.xls`;

            return from(cashboxesClient.downloadCashBoxReplacementHistoryAsExcel(taxNumber)).pipe(
                tap((fileData) => downloadDataAsFile(fileName, fileData)),
                mapTo(downloadReplacementHistorySuccessAction()),
                catchError((err: AxiosError) =>
                    of(
                        downloadReplacementHistoryErrorAction(
                            parseError(err, i18n.t('errors.failedUploadFileName', { fileName })),
                        ),
                    ),
                ),
            );
        }),
    );
};
